import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-mobile-list',
    templateUrl: './mobile-list.component.html',
    styleUrls: ['./mobile-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MobileListComponent implements OnInit {

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
    }

    onConfirmOTP() {
        this.router.navigate(['../confirm-otp'], { relativeTo: this.route });
    }

}
